import { render, staticRenderFns } from "./ResourceuploadBrowsing.vue?vue&type=template&id=dceb3474&scoped=true"
import script from "./ResourceuploadBrowsing.vue?vue&type=script&lang=js"
export * from "./ResourceuploadBrowsing.vue?vue&type=script&lang=js"
import style0 from "./ResourceuploadBrowsing.vue?vue&type=style&index=0&id=dceb3474&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceb3474",
  null
  
)

export default component.exports